import React from "react";

interface TextInputProps {
  label: string;
  description?: string;
  placeholder?: string;
  value: string | undefined;
  onChange: (value: string) => void;
  required?: boolean;
  multiline?: boolean;
  type?: "text" | "email" | "tel" | "url";
  maxLength?: number;
}

export function TextInput({
  label,
  description,
  placeholder,
  value = "",
  onChange,
  multiline = false,
  type = "text",
  maxLength,
}: TextInputProps) {
  const inputClasses = `
    w-full px-4 py-3 rounded-xl border-2 border-[var(--dug-border)]
    bg-[var(--dug-bg-surface)] text-[var(--dug-text-primary)]
    placeholder:text-[var(--dug-text-muted)]
    focus:outline-none focus:border-[var(--dug-coral)] focus:ring-2 focus:ring-[var(--dug-coral)]/20
    transition-all
  `;

  return (
    <div className="space-y-3">
      <div>
        <label className="text-lg font-semibold text-[var(--dug-text-primary)] block">
          {label}
        </label>
        {description && (
          <p className="text-sm text-[var(--dug-text-muted)] mt-1">{description}</p>
        )}
      </div>

      {multiline ? (
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          maxLength={maxLength}
          rows={4}
          className={`${inputClasses} resize-none`}
        />
      ) : (
        <input
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          maxLength={maxLength}
          className={inputClasses}
        />
      )}

      {maxLength && (
        <p className="text-xs text-[var(--dug-text-muted)] text-right">
          {value.length}/{maxLength}
        </p>
      )}
    </div>
  );
}
